import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconInfo } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { openPollsPanel } from '../../../chat/actions.any';
import { arePollsDisabled } from '../../../conference/functions.any';
/**
 * Component that renders a button to open the polls panel.
 *
 * @augments AbstractButton
 */
class PollsButton extends AbstractButton {
    icon = IconInfo;
    label = 'toolbar.polls';
    tooltip = 'toolbar.polls';
    /**
     * Handles clicking the button to open the polls panel.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(openPollsPanel());
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {Object} - Mapped props.
 */
function mapStateToProps(state) {
    return {
        visible: !arePollsDisabled(state)
    };
}
export default translate(connect(mapStateToProps)(PollsButton));
